module.exports = __webpack_public_path__ + "img/product-list.0d7ac384.svg";